export const getInitialValues = ({
    hasPolicyAgreement,
    hasExtendedNewsletterForm,
}: {
    hasPolicyAgreement: boolean;
    hasExtendedNewsletterForm: boolean;
}) => {
    return {
        email: "",
        ...(hasPolicyAgreement && { policy: false }),
        ...(hasExtendedNewsletterForm && { name: "" }),
    };
};
